<template>
    <div class="f-list-like-btn"
        :class="{'f-list-like-btn-hover': isPc}"
        @click="changeLikeState">
        <div :class="isLike?'btn-content-already':'btn-content'">
            <span v-if="!isLike" class="fa fa-heart-o icon"></span>
            <span v-if="isLike" class="fa fa-heart icon-already"></span>
            <span class="like-info">{{isLikeTips}}</span>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-content/likeBtn.less';
</style>

<script>
import {mapState} from 'vuex';
export default {
    props: {
        isLike: {
            'type': Number,
            'default': 0
        }
    },
    computed: {
        ...mapState({
            isPc: state => state.common.isPc
        }),
        isLikeTips: {
            get() {
                return this.isLike ? '已点赞' : '点赞';
            }
        }
    },
    methods: {
        changeLikeState() {
            this.$emit('like');
        }
    }
};
</script>